import Utility from "./utility";

const comparableContainers = document.querySelectorAll('.wp-block-create-block-services');

if (comparableContainers) {
    comparableContainers.forEach((container) => {
        const utility = new Utility(container);
    });
}

